import BasePage from "@Scripts/Pages/BasePage";

export default class ClassifiedListPage extends BasePage {
    public static async init() {
        await super.init();

        this.setSearch();

        $("#Brand").on("change", x => {
            this.setDropdownModel("change");
        });

        if ($("#Brand").val()) {
            this.setDropdownModel("initial");
        }

        this.checkIsInViewport();
    }

    private static setDropdownModel(action: string) {
        let dropdown = $("#Model");

        if ($("#Brand").val()) {
            (<any>window).App.instances.vm.$store.dispatch("motorcycleStore/getInfoBikeModels", {
                brand: $("#Brand").val()
            }).then((response) => {
                const valueModel = $("#Model").val();
                dropdown.empty();
                dropdown.append($("<option />").val("").text("..."));
                $.each(response.data, function () {
                    dropdown.append($("<option />").val(this.value).text(this.title));
                });
                if (action === "initial") {
                    $("#Model").val(valueModel);
                }
            });

        } else {
            dropdown.empty();
            dropdown.append($("<option />").val("").text("..."));
        }
    }

    private static setSearch() {
        $("#SearchButton").on("click", function () {
            var filters = [],
                filterCount = 0,
                queryString = "",
                minDisplacement = $("#MinDisplacement").val(),
                maxDisplacement = $("#MaxDisplacement").val(),
                minYear = $("#MinYear").val(),
                maxYear = $("#MaxYear").val(),
                maxMileage = $("#MaxMileage").val(),
                maxPrice = $("#MaxPrice").val(),
                brand = $("#Brand").val(),
                model = $("#Model").val(),
                province = $("#Province").val(),
                selectedOccasionTypes = [];

            if (minDisplacement) {
                filters.push("MinDisplacement=" + minDisplacement);
                filterCount++;
            }

            if (maxDisplacement) {
                filters.push("MaxDisplacement=" + maxDisplacement);
                filterCount++;
            }

            if (minYear) {
                filters.push("MinYear=" + minYear);
                filterCount++;
            }

            if (maxYear) {
                filters.push("MaxYear=" + maxYear);
                filterCount++;
            }

            if (maxMileage) {
                filters.push("MaxMileage=" + maxMileage);
                filterCount++;
            }

            if (maxPrice) {
                filters.push("MaxPrice=" + maxPrice);
                filterCount++;
            }

            if (brand) {
                filters.push("Brand=" + brand);
                filterCount++;
            }

            if (model) {
                filters.push("Model=" + model);
                filterCount++;
            }

            if (province) {
                filters.push("Province=" + province);
                filterCount++;
            }

            $("input:checkbox[name=SelectedOccasionTypes]:checked").each(function () {
                selectedOccasionTypes.push($(this).val());
            });

            if (selectedOccasionTypes.length) {
                filters.push("SelectedOccasionTypes=" + selectedOccasionTypes.toString());
                filterCount++;
            }

            if (filterCount !== 0) {
                queryString = filters.join("&");
                window.location.href = (<any>window).App.routes.ClassifiedPTW_List + "?" + queryString;
            } else {
                window.location.href = (<any>window).App.routes.ClassifiedPTW_List;
            }
        });
    }

    private static checkIsInViewport() {
        let myElement = <any>document.querySelector("[data-selected='true']");
        let box = <any>document.querySelector(".pagination");

        box.scrollLeft = myElement.offsetLeft - box.offsetLeft - 25;
    }
}